// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyDbIltU-vZYTU5T4OYPJqpsFM_pF_OrWpM",
  authDomain: "swalook-crm.firebaseapp.com",
  projectId: "swalook-crm",
  storageBucket: "swalook-crm.firebasestorage.app",
  messagingSenderId: "192647184702",
  appId: "1:192647184702:web:d1301994a55548717d2c6f"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Storage
const storage = getStorage(app);

export { storage };

